import template from './conflicted_slot.html'
import './conflicted_slot.css'

export default {
  template,
  controller: 'conflictedSlotController as conflictedSlot',
  bindings: { data: '=', position: '=' }
}
